import React from 'react';
import ReactDOM from 'react-dom/client';
import './styles/index.scss';
import { applyBrandTheme, readCachedBrand } from './brand/applyBrandTheme';
import { DEFAULT_COMPANY_BRAND } from './brand/types';
import App from './App';
import reportWebVitals from './reportWebVitals';

applyBrandTheme(readCachedBrand() || DEFAULT_COMPANY_BRAND);

// ngrok free plan displays an HTML warning splash page unless this header is present.
// Student app uses `fetch` in a few places (e.g. image loading), so patch globally once.
if (typeof window !== 'undefined') {
  const w = window as any;
  if (!w.__ngrokFetchPatched) {
    w.__ngrokFetchPatched = true;
    const originalFetch = window.fetch.bind(window);
    window.fetch = (input: RequestInfo | URL, init?: RequestInit) => {
      const tokenFromStorage = localStorage.getItem('student_token');
      const headers = new Headers(init?.headers as any);
      if (tokenFromStorage && !headers.has('Authorization')) {
        headers.set('Authorization', `Bearer ${tokenFromStorage}`);
      }
      headers.set('ngrok-skip-browser-warning', '1');
      return originalFetch(input, { ...init, headers });
    };
  }
}

const root = ReactDOM.createRoot(
  document.getElementById('root') as HTMLElement
);
root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
